export default "__VITE_ASSET__faa79bc5__"